export default __webpack_public_path__ + "static/taskdef2-9655b192d7694e399b0f2d748c78d638.png";